import { createContext, useContext, useLayoutEffect } from 'react'

const ThemeContext = createContext(null)

// Force dark mode always — Panerai theme is the only theme
function applyDarkMode() {
  const root = document.documentElement
  root.classList.add('dark')
  root.classList.remove('light')
  root.style.backgroundColor = '#0D0D0D'
  root.style.colorScheme = 'dark'
}

// Apply immediately before any rendering
if (typeof window !== 'undefined') {
  applyDarkMode()
}

export function ThemeProvider({ children }) {
  useLayoutEffect(() => {
    applyDarkMode()
  }, [])

  return (
    <ThemeContext.Provider value={{
      theme: 'dark',
      isDark: true,
      isLight: false,
      toggleTheme: () => {},
      setDarkMode: () => {},
      setLightMode: () => {}
    }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}
